import { useEffect } from 'react';
import { ShipperDetailsResponse } from 'src/apis/organisation-service/types';
import { useAxios } from 'src/hooks/use-axios';
import { OrganisationDetailsRequest } from 'src/pages/settings/organisation/company-information/use-organisation-details';

export function useShipperDetails({
  organisationDetails,
}: {
  organisationDetails: OrganisationDetailsRequest;
}) {
  const shipperDetails = useAxios(
    (axios, signal, url) =>
      axios.request<ShipperDetailsResponse>({
        signal,
        url,
      }),
    { neededOnPageLoad: true }
  );

  useEffect(() => {
    if (!organisationDetails.response?.data._links.shipperDetails?.href) return;
    shipperDetails.execute(
      organisationDetails.response.data._links.shipperDetails.href
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [organisationDetails.response]);

  return shipperDetails;
}

export type ShipperDetailsRequest = ReturnType<typeof useShipperDetails>;
